<ng-template #dnSpinIndicator>
    <app-loading-mark></app-loading-mark>
</ng-template>
<router-outlet></router-outlet>

<!-- App-wide update banner: fixed-position, so it renders correctly regardless of
     where in the DOM it sits relative to whichever route is active (logged in or not). -->
<div class="app-update-banner" *ngIf="updateAvailable$ | async">
    <span class="app-update-banner__msg">
        <span nz-icon nzType="info-circle" nzTheme="fill"></span>
        A new version of Display NOW is available.
    </span>
    <span class="app-update-banner__actions">
        <button nz-button nzType="primary" nzSize="small" (click)="applyUpdate()">Refresh now</button>
        <button class="app-update-banner__close" (click)="dismissUpdateBanner()" aria-label="Dismiss">
            <span nz-icon nzType="close"></span>
        </button>
    </span>
</div>